import NewPurchaseOrder from "../../../../components/@documents/purchase_orders/NewPurchaseOrder";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function PurchaseOrderNewPage() {

    return (
        <NewPurchaseOrder 
            routeType={routeTypes.admin}
        />
    )
}